module.exports = __webpack_public_path__ + "img/cinema5.ec619c18.jpg";